import { Button } from "devextreme-react/button";

function ToolbarAfterApprove({
  handleOpenPopup,
  selectedItems,
  middleware,
  isDisable,
  handleSendApprove,
  type,
}) {
  return (
    <div className="form_select_box_list_approve">
      {middleware && middleware.ApproveState && (
        <>
          <Button
            type="default"
            stylingMode="outlined"
            // text={formatMessage("Approve")}
            className="button-rounded mr-1"
            onClick={() => {
              const newDataApprove = {
                items: [...selectedItems],
                type: 1,
                category: type,
              };
              handleSendApprove(newDataApprove);
            }}
            disabled={isDisable}
            icon="check"
          />
          <Button
            type="danger"
            stylingMode="outlined"
            // text={formatMessage("Reject")}
            className="button-rounded"
            icon="close"
            disabled={isDisable}
            onClick={() => {
              const newDataReject = {
                items: [...selectedItems],
                type: 0,
                category: type,
              };
              handleOpenPopup(newDataReject);
            }}
          />
        </>
      )}
    </div>
  );
}

export default ToolbarAfterApprove;
